<template>
    <div>
        <div  class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="flex items-center gap-4 ">
                    <img width="35" src="../../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">
                    <div>
                        <h2 class="font-bold">{{ tierTitle }} Tier</h2>
                        <p>Valid through 30th June, 2025</p>
                    </div>    
                </div> 
                <div class="w-full">
                    <div class=" w-full mt-2  flex justify-between">
                        <h3>38 Deliveries</h3>
                        <p>Qualifying Period: Jan 1 - Mar 31</p>
                    </div>
                    <div class="deliveries-time-line mt-2 flex">
                        <div class="h-1">.</div>
                        <div class="h-1">.</div>
                    </div>
                </div>  
                <div class="px-2 py-2 mt-2">
                    <p>You need to complete 12 additional deliveries 
                        to qualify for the Gold Tier, valid through June 30th.</p>
                </div>  
                <div class="mt-2">
                    <div class="flex justify-between">
                        <p>Minimum Customer Rating:</p>
                        <p>4.5</p>
                    </div>
                    <hr class="mt-2">
                </div>   
                <div class="flex justify-between items-center mt-4 py-2 px-2">
                    <div class="flex items-center gap-2">
                        <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">
                        <p>Unlocked Rewards (Silver)</p>
                    </div>
                    <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/unlock.svg" alt="padlock" >
                </div>   
                <div  class=" mt-4 py-2 px-2">
                    <div v-for="(title, index) in titles" :key="index" class="flex justify-between items-center ">
                        <p >{{ title }}</p>
                        <img width="20" src="../../../../../views/3pl/BillingandCollection/icons/check-mark.svg" alt="padlock" >
                    </div>             
                </div>
                <div class="flex justify-between items-center mt-2 py-2 px-2">
                    <div class="flex items-center gap-2">
                        <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/people.svg" alt="star">
                        <p>Additional Perks</p>
                    </div>
                    <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/unlock.svg" alt="padlock" >
                </div> 
                <div class="flex justify-end mt-2" @click="openWorkModal">
                    <button class="py-2 px-4" >
                        How it works
                    </button>
                </div>               
            </div>
        </div>

    </div>   

</template>

<script>
export default {
  data() {
    return {
        titles: [
             "Commission on Deliveries", 
             "Access to thousands of delivery orders in your area", 
             "Weekly performance insights (via dashboard & email)",
             "Instant Cashout (get paid within 24 hours on completed deliveries)"],
      currentTier: 'silver', 
    
    };
  },

  methods: {
      async getViewTierHistory() {
      let response = await this.$_getTeirCategory({ customerType: '3PL', fleetType: "Bike" })

      if (['silver', 'gold', 'platinum', 'diamond'].includes(response.data.baselineTier?.toLowerCase())) {
        this.currentTier = response.data.baselineTier;
        
      } else {
        
        this.currentTier = response.data.baselineTier;

      }

    },

    closeModal() {
      this.$emit("close-modal", close)
    },
    openWorkModal() {
      this.$emit("open-work-modal", open)
    }

  },
  computed: {
     tierTitle() {
      switch (this.currentTier) {
        case 'silver':
          return 'Silver';
        case 'No Tier':
          return 'No Tier';
        case 'gold':
          return 'Gold';
        case 'platinum':
          return 'Platinum';
        case 'diamond':
          return 'Diamond';
        default:
          return 'Silver';
      }
    },
       tierPercentage() {
      switch (this.currentTier) {
        case 'silver':
          return '15%';
        case 'gold':
          return '25%';
        case 'platinum':
          return '35%';
        case 'diamond':
          return '45%';
        case 'No Tier':
          return '';
        default:
          return '';
      }
    },
  },
  mounted() {
    this.getViewTierHistory()
  },

}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-items: center; */
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
 
}

.modal-content>:nth-child(2)>:nth-child(2)>div{
   flex-basis: 50%;
}
.modal-content>:nth-child(3){
    background-color: #F2F7FC;
    border-radius: 8px;
}
.modal-content>:nth-child(3) p{
    color: #383F51;
    font-size: 14px;
    font-weight: 400;
}
.modal-content>:nth-child(4)>div p{
    color: #7A90A7;
    font-size: 14px;
    font-weight: 400;
}
.modal-content>:nth-child(4) hr{
    border: 0.5px solid #7A90A7;
}
.modal-content>:nth-child(5),.modal-content>:nth-child(6){
   border: 1px solid #09B78A;
   background-color: #F2F7FC;
   border-radius: 8px;
}

.modal-content>:nth-child(5)>div p{
    color: #383F51;
    font-size: 12px;
    font-weight: 600;
}
.modal-content>:nth-child(7){
   border: 1px solid #F7B538;
   background-color: #F7B5380D;
   border-radius: 8px;
}
.modal-content>:nth-child(7)>div p{
   color: #14171F;
   font-weight: 600;
   font-size: 12px;
}

.modal-content>:nth-child(8) button{
   border: none;
   background-color: #10233E;
   color: #EBF2FA;
   border-radius: 8px;
   font-size: 16px;
}
h2{
    font-size: 16px;
    color: #383F51;
}

.deliveries-time-line>:nth-child(1){
    background-color: #09B78A;
    color: #09B78A;
}
.deliveries-time-line>:nth-child(2){
    background-color: #DAE8F6;  
    color: #DAE8F6;  
}
p{
    font-weight: 400;
    font-size: 12px;
    color: #7A90A7;
}
 h3{
    font-weight: 600;
    font-size: 14px;
    color: #09B78A;
}

</style>